import React from 'react';
import * as types from 'hellospa/page/prep-and-send/data/types';

export function useAreFilesReady(files: types.UserFile[]) {
  const [isValid, setValid] = React.useState(false);

  React.useEffect(() => {
    async function run() {
      const tmp = await types.multiUserFileSchema.isValid({ files });
      setValid((isValid) => isValid || tmp);
    }

    if (!isValid) {
      run();
    }
  }, [files, isValid]);
  return isValid;
}
